import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import fileDownload from 'js-file-download';
import store from '@/state/store';
import {
    introductionAPI,
} from '@samclick-static-urls';
import { sendGet, sendGetBlob } from '@samclick-api-client';
import Payload from './payload';
import * as appStorageUtil from '@/utils/localstorage-util';
import { SHOW_BG } from '@/utils/localstorage-util';


class IntroductionState {
    public loading: boolean = false

    public beginnersGuide: object[] = []
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'introductions',
})
class IntroductionStore extends VuexModule {
    introductionStore: IntroductionState = new IntroductionState();

    @Mutation
    INTRODUCTION_REINITIALIZE() {
        this.introductionStore = new IntroductionState();
    }

    @Mutation
    SET_INTRODUCTION_LOADING(loading: boolean) {
        this.introductionStore.loading = loading;
    }

  @Mutation
    SET_BEGINNERS_GUIDE_LIST(response: object[]) {
        this.introductionStore.beginnersGuide = response || [];
    }

  @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_INTRODUCTION_LOADING', show);
  }

    @Action({ rawError: true })
  destroyIntroduction() {
      this.context.commit('INTRODUCTION_REINITIALIZE');
  }

  @Action({ rawError: true })
    getBeginnersGuide(payload: Payload = new Payload()) {
        this.showLoader(payload.activateLoader);
        return new Promise((resolve, reject) => {
            sendGetBlob(introductionAPI.getBeginnersGuide, payload.data).then((response) => {
                this.showLoader(false);
                fileDownload(response.data, payload.data.fileName);
                resolve(response);
            }, (error) => {
                this.showLoader(false);
                reject(error.response);
            });
        });
    }

  @Action({ rawError: true })
  getListBeginnersGuide(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(introductionAPI.getListBeginnersGuide, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_BEGINNERS_GUIDE_LIST', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getFilteredBeginnersGuide(payload: Payload = new Payload()) {
      sendGet(introductionAPI.getListBeginnersGuide, payload.data).then((response) => {
          if (response.data.length === 0) {
              appStorageUtil.setSessionItem(SHOW_BG, false);
          }
      });
  }
}


export default getModule(IntroductionStore);
